import script from "./SuggestedDrgPane.vue?vue&type=script&lang=ts&setup=true"
export * from "./SuggestedDrgPane.vue?vue&type=script&lang=ts&setup=true"

import "./SuggestedDrgPane.vue?vue&type=style&index=0&id=494c3a3e&lang=scss"

const __exports__ = script;

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
